import { ServerFetch } from '../main-model'

export default class ProductSacleModel extends ServerFetch {
    getProductScaleBy = (data) => this.authFetch({
        url: 'product-scale/getProductScaleBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}